import { Component, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import {
    CclNavbarSecondaryService,
    CclMessageService,
    CclDrawerService,
    CclPopupService
} from "certain-common-library";
import { SharedService } from "../../../modules/shared/services/shared.service";
import { Subscription } from "rxjs";
import { AttendeeSessionService } from "../../../modules/shared/services/attendee-session.service";
import { CookieService } from "ngx-cookie";
import { FlashMessagesService } from "angular2-flash-messages";

@Component({
    selector: "app-item-context",
    templateUrl: "./catalog-context.view.html",
    styleUrls: []
})
export class CatalogContextView implements OnInit, AfterViewInit, OnDestroy {
    subscription: Subscription;
    headerConfig: any;
    htmlTopConfig: any;
    htmlBottomConfig: any;
    footerConfig: any;
    drawerControlConfig: any;
    tabConfig;
    additionalSetting;
    jsonConfig;
    loginConfig;
    filterConfig;
    toggleProfileDropdown: any = false;

    private tracks: any;

    constructor(
        private navSecondaryService: CclNavbarSecondaryService,
        public sharedService: SharedService,
        private messageService: CclMessageService,
        private drawerService: CclDrawerService,
        private popupService: CclPopupService,
        private attendeeSessionService: AttendeeSessionService,
        private cookieService: CookieService,
        private _flashMessagesService: FlashMessagesService
    ) {
        if (this.cookieService.get("catalog_" + this.sharedService.setup.id) != undefined) {
            var cookie = JSON.parse(this.cookieService.get("catalog_" + this.sharedService.setup.id));
            this.showHtmlTop = cookie.showHtmlTop;
        }

        this.navSecondaryService.includeSave = false;
        this.subscription = this.messageService.getMessage().subscribe((message) => this.changeContext(message));
        this.tabConfig = JSON.parse(this.sharedService.configs[this.sharedService.configTypes.TAB_CONFIG].config);
    }

    ngOnInit() {
        document.title = "Speaker Catalog - " + this.sharedService.setup.catalogName;
        if (!this.sharedService.isEmptyString(this.sharedService.errorStr)) {
            this._flashMessagesService.show(this.sharedService.errorStr, {
                cssClass: "alert-danger"
            });
        }

        this.jsonConfig = JSON.parse(this.sharedService.setup.layoutConfig);
        this.headerConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.HEADER_FOOTER.header].config
        );
        this.footerConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.HEADER_FOOTER.footer].config
        );
        this.htmlTopConfig = JSON.parse(this.sharedService.configs[this.sharedService.configTypes.HTML.top].config);
        this.htmlBottomConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.HTML.bottom].config
        );
        this.additionalSetting = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.ADDITIONAL_SETTING_CONFIG].config
        );
        // this.drawerControlConfig = JSON.parse(
        //     this.sharedService.configs[this.sharedService.configTypes.MYSESSION].config
        // ).drawer_button;
        // this.loginConfig = JSON.parse(this.sharedService.configs[this.sharedService.configTypes.LOGIN_POPUP].config);
        if (this.sharedService.configs[this.sharedService.configTypes.FILTER_CONFIG] != null) {
            this.filterConfig = JSON.parse(
                this.sharedService.configs[this.sharedService.configTypes.FILTER_CONFIG].config
            );
        }

        const headFragment = document.createRange().createContextualFragment(this.additionalSetting.header);
        const footFragment = document.createRange().createContextualFragment(this.additionalSetting.footer);
        document.getElementsByTagName("head")[0].appendChild(headFragment);
        document.getElementsByTagName("body")[0].appendChild(footFragment);
    }

    ngAfterViewInit(): void {}

    ngOnDestroy() {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    changeContext(message) {
        if (message.text == "update-context") {
            this.navSecondaryService.contextLabel =
                message.data.account.name + " - " + message.data.event.name + "-" + message.data.catalog.catalogName;
        } else if (message.text == "use-default") {
            this.openPopup(message.data.popupName, null);
        } else if (message.text == "toggle-cart") {
            this.toggleCart();
        } else if (message.text == "toggle-myschedule") {
            this.toggleMySchedule();
        }
    }

    openPopup(item, $event) {
        if ($event != null) {
            $event.stopPropagation();
        }
        let url = "";
        if (item == "login") {
            this.popupService.setPosition("center");
            this.popupService.setSize("small");
            this.popupService.togglePopup();
            this.sharedService.currentPopup = {
                title: null,
                navLinks: null,
                saveMessage: "reg-login",
                showFooter: false
            };
            url = "popup/login";
        }
        this.sharedService.navigateToOutlet("popup", url);
    }

    logout() {
        if (this.sharedService.loggedInAttendee != null) {
            this.attendeeSessionService.logout(this.sharedService.loggedInAttendee.uuid).subscribe((resp) => {
                this.sharedService.loggedInAttendee = null;
                sessionStorage.setItem(
                    "loggedInAttendee_" + this.sharedService.eventUUID,
                    this.sharedService.loggedInAttendee
                );
                this.cookieService.remove("attendeeId_" + this.sharedService.setup.id);
                this.cookieService.remove("attendeeUUID_" + this.sharedService.setup.id);
                this.cookieService.remove("REGISTRATION_SESS_UUID_" + this.sharedService.setup.id);
                this.attendeeSessionService.getSessionApiOnLogin();
                this.messageService.sendMessage("attendee-logout");
            });
        }
    }

    showSideBar: boolean = false;
    toggleSideBar() {
        this.showSideBar = !this.showSideBar;
    }

    showCart: boolean = false;
    toggleCart() {
        if (!this.showCart) {
            this.sharedService.favData.size = 0;
            this.sharedService.excData.size = 0;
            this.showCart = !this.showCart;
            this.sharedService.cartViewRender = true;
            this.sharedService.renderCartView();
        } else {
            this.showCart = !this.showCart;
            if (this.showCart == false) {
                this.sharedService.favData = {};
                this.sharedService.cartData = {};
            }
        }
    }
    showMySchedule: boolean = false;
    toggleMySchedule() {
        if (!this.showMySchedule) {
            this.messageService.sendMessage("update-my-schedule");
        } else {
            this.sharedService.showMyScheduleCalendar = false;
        }
        this.showMySchedule = !this.showMySchedule;
    }

    clearAllFilter() {
        this.messageService.sendMessage("clear-all-filter");
    }

    clearSingleFilter(filterType, id) {
        this.messageService.sendMessage("clear-single-filter", { filterType: filterType, id: id });
    }

    showHtmlTop: boolean = true;
    toggleHtmlTop() {
        this.showHtmlTop = !this.showHtmlTop;
        this.messageService.sendMessage("toggle-html-top", this.showHtmlTop);
    }
}
